import { UseFormSetValue } from "react-hook-form";
import { AccountCombobox } from "../../components/accounts/AccountCombobox";
import PickAddress from "../../components/shared/Addresses/PickAddress";
import SelectInput from "../../components/shared/Inputs/SelectInput";
import { TextInput } from "../../components/shared/Inputs/TextInput";
import { useEffect, useState } from "react";
import LoadingWheel from "../../components/shared/LoadingWheel";

import PriceFormat from "../../utils/priceFormat";
import useShippingPolicies from "../../data/useShippingPolicies";
import { IShippingPolicy } from "../../models/ShippingPolicy";
import { SearchContact } from "../../components/contacts/SearchContact";
import { SearchAccount } from "../../components/accounts/SearchAccount";
import { IAccount } from "../../models/account/IAccount";
import SwitchInput from "../../components/shared/Inputs/SwitchInput";

interface IBasketInvoiceInputsProps {
  register: any;
  setValue: UseFormSetValue<any>;
  watch: (name: string) => any;
  setSelectedAccount: (account: any) => void;
  selectedAccount?: IAccount | null;
  disabled?: boolean;
  showTaxOption?: boolean;
}

export default function BasketInvoiceInputs({ register, setValue, watch, setSelectedAccount, selectedAccount, disabled, showTaxOption = true }: IBasketInvoiceInputsProps) {
  const { shippingPolicies: allShippingPolicies } = useShippingPolicies();

  const [shippingPolicies, setShippingPolicies] = useState<Record<string, number | string>[]>([]);
  const [loading, setIsLoading] = useState(true);

  const paymentMethods = [
    { id: 0, name: "Cash" },
    { id: 1, name: "Card" },
    // { id: 2, name: "eBay" },
    { id: 3, name: "Stripe" },
    { id: 4, name: "Bank Transfer" },
    { id: 5, name: "Cheque" },
  ];

  useEffect(() => {
    if (allShippingPolicies.isLoading) return;
    if (!allShippingPolicies.data?.data) return;

    const shipping = allShippingPolicies.data.data.map((policy: IShippingPolicy) => ({
      id: policy.id,
      name: `${policy.name} - ${PriceFormat(policy.price)}`
    }));

    setShippingPolicies(shipping);
    // Only default when nothing is chosen - a basket loaded from a quote arrives with its own policy
    const current = watch("shippingPolicyId");
    if (current === undefined || current === null || current === "0" || current === "") {
      setValue("shippingPolicyId", shipping[0]?.id || "0");
    }

    setIsLoading(false);

  }, [allShippingPolicies.isLoading, allShippingPolicies.data]);

  useEffect(() => {
    if (selectedAccount) {
      console.log("Selected account changed:", selectedAccount);
    }
  }, [selectedAccount]);


  if (loading) return <div className="flex flex-col gap-4 mt-4"><LoadingWheel /></div>;

  return (
    <div className="flex flex-col gap-4 mt-4">

      <SearchAccount
        onAccountSelect={setSelectedAccount}
        label="Search Account"
        selectedAccount={selectedAccount}
        disabled={disabled}
      />

      {/* Payment method */}
      <SelectInput options={paymentMethods} label="Payment Method" register={register} registerName={"paymentMethod"} setValue={setValue} watch={watch} disabled={disabled} />

      <SelectInput options={shippingPolicies} label="Shipping Policy" register={register} registerName={"shippingPolicyId"} setValue={setValue} watch={watch} disabled={disabled} />

      <TextInput richText label={"Notes"} register={register} registerName={"notes"} disabled={disabled} />

      {/* Address picker */}
      <PickAddress register={register} setValue={setValue} watch={watch} disabled={disabled} />

      {showTaxOption && (
        <SwitchInput
          label="Add Tax to Total"
          register={register}
          registerName={"addTaxToTotal"}
          setValue={setValue}
          watch={watch}
        />
      )}
    </div>
  )
}